import { Components, Theme } from '@mui/material/styles';

import Autocomplete from './autocomplete';
import Button from './button';
import IconButton from './icon-button';
import Link from './link';
import OutlinedInput from './outlined-input';
import Radio from './radio';
import Switch from './switch';
import Tabs from './tabs';
import TextField from './text-field';
import Tooltip from './tooltip';
import Typography from './typography';

export function componentOverrides(theme: Theme): Components<Theme> {
  return {
    ...Autocomplete(theme),
    ...Button(theme),
    ...IconButton(theme),
    ...Link(theme),
    ...OutlinedInput(theme),
    ...Radio(theme),
    ...Switch(theme),
    ...Tabs(theme),
    ...TextField(theme),
    ...Tooltip(theme),
    ...Typography(theme),
  };
}
